import { render, staticRenderFns } from "./DiscountandPromotion.vue?vue&type=template&id=382014ea&scoped=true"
import script from "./DiscountandPromotion.vue?vue&type=script&lang=js"
export * from "./DiscountandPromotion.vue?vue&type=script&lang=js"
import style0 from "./DiscountandPromotion.vue?vue&type=style&index=0&id=382014ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382014ea",
  null
  
)

export default component.exports